"use strict";
function pagination(){
    document.querySelectorAll(".load-more").forEach((btn) => {
      btn.classList.remove('loading');
      var url = btn.getAttribute('href');
      if (btn.classList.contains("infinite")){
        var observer = new IntersectionObserver(
          function(entries){
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1){
                loadMoreproducts(url);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(btn);
      } else {
        btn.addEventListener("click",(e) => {
            e.preventDefault();
            btn.classList.add('loading');
            loadMoreproducts(url);
          },
          false
        );
      }
    });
}
pagination();
function loadMoreproducts(url){
    fetch(url).then((response) => response.text()).then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html'),
        products = document.getElementById('collection-products'),
        productsSource = html.querySelector('#collection-products').innerHTML,
        pagination = document.getElementById('pagination'),
        paginationSource = html.querySelector('#pagination');

      if(products) products.insertAdjacentHTML('beforeend', productsSource);
      if(pagination && paginationSource) {
        pagination.innerHTML = paginationSource.innerHTML;
      } else {
        pagination.innerHTML = '';
      }
    })
    .finally(() => {
      pagination();
      if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
      initializeVideos();initBgimages();
      initializeScrollAnimationTrigger();
    })
    .catch((e) => {
      console.error(e);
    });
}

class FiltersForm extends HTMLElement {
  constructor() {
      super();
      var _this = this,
        fbtns = document.querySelectorAll(".btn-filter"),
        topFilters = document.querySelector(".filter-horizontal");

      this.secId = this.dataset.id;
      this.mql = window.matchMedia('(min-width: 767px)');
  
      fbtns.forEach((btn) =>
        btn.addEventListener('click', this.mobileFilters.bind(this))
      );
      if(topFilters && this.mql.matches === true) this.blockToggle();
      this.selectFilters();
      this.priceRangeSlider();
      this.numRangeSlider();
      this.removeFilters();
      this.selectSort();

      document.addEventListener('change', function(e){
        if (!e.target.classList.contains('optTag')) return;

        var URL = _this.dataset.url,
            paramString = new URLSearchParams(window.location.search),
            productFilters = document.querySelectorAll('input.optTag'),
            newTags = [],
            bytags = true;

        productFilters.forEach(function(el){
            if(el.value && el.checked){
                newTags.push(el.value);
            }
        });

        if (newTags.length) {
            var tags = newTags.join('+');
            _this.renderSectionFromFetch(URL + '/' + tags + '?' + paramString, bytags);
        } else {
            _this.renderSectionFromFetch(URL + '?' + paramString, bytags);
        }
      });

  }
  selectSort(){
    var shortby = document.getElementById('sort-by');
    shortby.addEventListener('change', this.onFormSubmit.bind(this));
  }
  selectFilters(){
    var filters = this.querySelectorAll('input.dyfl, .price-range');
    filters.forEach((filter) =>
       filter.addEventListener('change', this.onFormSubmit.bind(this))
    );
  }
  priceRangeSlider(){
    const isPriceRange = document.getElementById('priceSlider');
    if(!isPriceRange) return;
    const priceSlider = document.getElementById('priceSlider'),
      min = document.getElementById('Filter-Price-GTE'),
      max = document.getElementById('Filter-Price-LTE');

    priceSlider.addEventListener('change', (evt) => {
        min.value = evt.detail.value1.toString();
        max.value = evt.detail.value2.toString();
    });
    priceSlider.addEventListener('onMouseUp', (evt) => {
      min.dispatchEvent(new Event("change"));
    });
    priceSlider.addEventListener('touchend', (evt) => {
      min.dispatchEvent(new Event("change"));
    });
  }
  numRangeSlider(){
    var _this = this;
    this.querySelectorAll('[data-num-slider]').forEach((wrap) => {
      const slider = wrap.querySelector('.num-range-slider'),
        handle = wrap.getAttribute('data-num-slider') || '',
        unit = wrap.getAttribute('data-unit') || '',
        label = wrap.querySelector('.num-slider__label'),
        minInput = wrap.querySelector('.num-slider__min'),
        maxInput = wrap.querySelector('.num-slider__max'),
        hMin = wrap.querySelector('.num-slider__hmin'),
        hMax = wrap.querySelector('.num-slider__hmax'),
        checkboxes = wrap.querySelectorAll('.num-slider__cb');
      if(!slider || slider.dataset.bound) return;
      slider.dataset.bound = '1';

      const r1 = (n) => Math.round(parseFloat(n) * 10) / 10;
      const lo = r1(slider.getAttribute('min')),
        hi = r1(slider.getAttribute('max'));
      const clamp = (n) => Math.min(hi, Math.max(lo, isNaN(n) ? lo : n));
      const anyChecked = () => Array.prototype.some.call(checkboxes, (cb) => cb.checked);
      const fmt = (a, b) => r1(a) + ' \u2013 ' + r1(b) + (unit ? ' ' + unit : '');
      const paramName = checkboxes.length ? (checkboxes[0].getAttribute('name') || '') : '';

      // Hidden carriers keep the *dragged* (continuous) range in the URL, so the handles
      // stay where the user dragged them instead of snapping/merging to discrete values.
      const setCarriers = (on, l, r) => {
        if(hMin){ hMin.disabled = !on; hMin.value = on ? r1(l) : ''; }
        if(hMax){ hMax.disabled = !on; hMax.value = on ? r1(r) : ''; }
      };
      const setInputs = (l, r) => {
        if(minInput && document.activeElement !== minInput) minInput.value = r1(l);
        if(maxInput && document.activeElement !== maxInput) maxInput.value = r1(r);
        if(label){ label.textContent = fmt(l, r); label.dataset.min = r1(l); label.dataset.max = r1(r); }
      };
      // Move the two handles WITHOUT rebuilding the element: setting the value1/value2
      // attributes is picked up by the library's MutationObserver -> setValue(pointer).
      const setHandles = (l, r) => {
        slider.setAttribute('value1', r1(l));
        slider.setAttribute('value2', r1(r));
      };

      // URL that removes this filter entirely (used as the single chip's href)
      const removeUrl = () => {
        const u = new URL(window.location.href);
        if(paramName) u.searchParams.delete(paramName);
        u.searchParams.delete('sl-' + handle + '-min');
        u.searchParams.delete('sl-' + handle + '-max');
        return u.pathname + '?' + u.searchParams.toString();
      };

      // Collapse this filter's individual active-filter chips into ONE range chip.
      const renderChip = (l, r) => {
        const active = document.getElementById('active-filters');
        if(!active) return;
        const ex = active.querySelector('[data-slider-chip="' + handle + '"]');
        if(ex) ex.remove();
        const matches = paramName
          ? Array.prototype.slice.call(active.querySelectorAll('a.active-fl[data-fl-param]')).filter((a) => a.getAttribute('data-fl-param') === paramName)
          : [];
        if(!matches.length) return;
        const chip = document.createElement('a');
        chip.className = 'active-fl';
        chip.setAttribute('data-slider-chip', handle);
        chip.setAttribute('href', removeUrl());
        chip.innerHTML = fmt(l, r) + ' <svg class="at-icon"><use xlink:href="#icon-close"></use></svg>';
        matches[0].parentNode.insertBefore(chip, matches[0]);
        matches.forEach((a) => a.remove());
      };

      // ----- position the handles + chip on every (re)render -----
      // Handle position is driven ONLY by the carriers (the dragged range), regardless of
      // which discrete values got selected -> the handles never snap/jump back to min/max.
      const sp = new URLSearchParams(window.location.search);
      const uMin = sp.get('sl-' + handle + '-min'), uMax = sp.get('sl-' + handle + '-max');
      let dispL, dispR;
      if(uMin !== null && uMax !== null){
        dispL = clamp(r1(uMin)); dispR = clamp(r1(uMax));
        if(dispL > dispR){ const t = dispL; dispL = dispR; dispR = t; }
        setHandles(dispL, dispR);
        setCarriers(true, dispL, dispR);
      } else {
        setCarriers(false);
        dispL = clamp(r1(slider.getAttribute('value1')));
        dispR = clamp(r1(slider.getAttribute('value2')));
      }
      if(anyChecked()) renderChip(dispL, dispR);
      setInputs(dispL, dispR);
      let curL = dispL, curR = dispR;

      // dragging the slider -> sync the boxes + label live (fetch happens on release)
      slider.addEventListener('change', (evt) => {
        curL = r1(evt.detail.value1);
        curR = r1(evt.detail.value2);
        setInputs(curL, curR);
      });

      // typing in a box -> update the label live
      const onType = () => {
        let l = clamp(r1(minInput.value)), r = clamp(r1(maxInput.value));
        if(l > r){ const t = l; l = r; r = t; }
        if(label){ label.textContent = fmt(l, r); }
      };
      if(minInput) minInput.addEventListener('input', onType);
      if(maxInput) maxInput.addEventListener('input', onType);

      // commit -> move handles to range, tick in-range boxes, persist range, refresh list
      const commit = () => {
        let l = minInput ? parseFloat(minInput.value) : NaN;
        let r = maxInput ? parseFloat(maxInput.value) : NaN;
        l = isNaN(l) ? curL : clamp(r1(l));
        r = isNaN(r) ? curR : clamp(r1(r));
        if(l > r){ const t = l; l = r; r = t; }
        if(minInput) minInput.value = r1(l);
        if(maxInput) maxInput.value = r1(r);
        curL = l; curR = r;
        setHandles(l, r);                         // typing in a box moves the handle too
        const isFull = (l <= lo && r >= hi);
        checkboxes.forEach((cb) => {
          const num = r1(cb.dataset.num),
            inRange = num >= l && num <= r,
            allowed = !cb.disabled || cb.checked;
          cb.checked = !isFull && inRange && allowed;
        });
        setCarriers(!isFull, l, r);
        _this.onFormSubmit();                     // refresh on every release / Enter
      };

      slider.addEventListener('onMouseUp', commit); // desktop release
      slider.addEventListener('touchend', commit);  // mobile release (no onMouseUp on touch)
      [minInput, maxInput].forEach((inp) => {
        if(!inp) return;
        inp.addEventListener('change', commit);
        inp.addEventListener('keydown', (e) => { if(e.key === 'Enter'){ e.preventDefault(); inp.blur(); } });
      });
    });
  }
  onFormSubmit(e){
    const flForm = this.querySelector('form'),
      formData = new FormData(flForm),
      params = new URLSearchParams(formData);
      this.renderSectionFromFetch(params);
  }
  renderSectionFromFetch(params,tags){
    if(this._rendering){ this._pendingRender = [params, tags]; return; }
    this._rendering = true;
    var url = `${window.location.pathname}?section_id=${this.secId}&${params.toString()}`
    if(tags){
        var url = `${params}&section_id=${this.secId}`
    }

    document.body.classList.add('load-filters');
    fetch(url).then((response) => response.text()).then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html'),
          products = document.getElementById('collection-products'),
          filters = this.querySelector('.filters-item__wrapper'),
          counts = document.getElementById('itemsCount'),
          pagination = document.getElementById('pagination'),
          paginationSource =  html.querySelector('#pagination'),
          activeFilters =  document.getElementById('active-filters');

        if(counts) counts.innerHTML = html.querySelector('#itemsCount').innerHTML;
        if(activeFilters) activeFilters.innerHTML = html.querySelector('#active-filters').innerHTML;
        if(products) products.innerHTML = html.querySelector('#collection-products').innerHTML;
        if(filters) filters.innerHTML = html.querySelector('.filters-item__wrapper').innerHTML;
        if(pagination && paginationSource) {
          pagination.innerHTML = paginationSource.innerHTML;
        } else if(pagination) {
          pagination.innerHTML = ' ';
        }
      })
      .finally(() => {
        if(tags){
            var url = `${params.toString()}`
        } else {
            var url = `${window.location.pathname}?${params.toString()}`
        }
        history.pushState({ page: url }, url, url);
        document.body.classList.remove('load-filters');
        this._rendering = false;
        if(this._pendingRender){ var pr = this._pendingRender; this._pendingRender = null; this.renderSectionFromFetch(pr[0], pr[1]); return; }
        this.selectFilters();this.priceRangeSlider();this.numRangeSlider();this.removeFilters();pagination();
        if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
        initializeVideos();initBgimages();
        initializeScrollAnimationTrigger();
      })
      .catch((e) => {
        console.error(e);
      });
  }
  removeFilters(){
    var _this = this,
        activeFl = document.querySelectorAll(".active-fl");
    activeFl.forEach((btn) => {
        btn.addEventListener("click",(e) => {
          e.preventDefault();
          var params = btn.getAttribute('href').split('?')[1];
          _this.renderSectionFromFetch(params);
        })
      });
  }
  mobileFilters(){
    var html = document.documentElement;
    html.classList.add('activ-filter','show-overly');
    const blocks = this.querySelectorAll('.filters-item');
    blocks.forEach((blk) => {
      blk.open = true;
    });
    document.querySelector(".closeFilter").addEventListener('click', function(e){
        html.classList.remove('activ-filter','show-overly');
    });
  }
  blockToggle(){
      const body = document.body,
        filters = document.querySelectorAll(".filter-horizontal .filters-title"),
        blocks = this.querySelectorAll('.filters-item');
      filters.forEach((blk) => {
        const act = blk.closest('.filters-item[open]');
        blocks.forEach((other) => {
           if(other !== act){
             other.removeAttribute('open');
           }
        });
      });
      body.addEventListener('click', function(e){
          blocks.forEach((blk) => {
            if(e.target.closest('.filters-item[open]')) return;
             blk.removeAttribute('open');
        });
      });
  }
}
customElements.define("filters-form", FiltersForm);

document.querySelectorAll(".change-view").forEach((btn) => {
  btn.addEventListener("click",(e) => {
     e.preventDefault();
      var view = btn.dataset.view,
        href = new URL(window.location.href);
      href.searchParams.set("type", view);
      window.location = href.toString();
  });
});
